/* eslint-disable no-useless-escape */
import { flattenArrayRecursive } from './FlattenArray'
import moment from 'moment'

/*
* Validates form data based on rules specified in each form's 'fields' object
* @param {Object} form
* @param {Object} fields
* @return Object or Boolean
*/
export function validate (form, fields) {
  let errors = {
    messages: [],
    empty: [],
    typeMismatch: [],
    valueLength: []
  }                                                                                                     // Holds a list of validation messages to be returned to view
  for (let f in form) {
    const fieldRules = fields.find(v => v.name === f)
    if (!fieldRules) continue                                                                           // In other words, skip if no validation needed
    const { name, required, msg, min, max, dataType, fieldType } = fieldRules
    const prettyFieldName = name[0].toUpperCase() + name.substring(1)
    if (required && !['boolean', 'decimal', 'integer'].includes(dataType) && !form[name]) {
      msg ? errors.messages.push(msg) : errors.messages.push(`${prettyFieldName} is required`)
      errors.empty.push(f)
      continue
    }
    if ((form[f] || required) && fieldType === 'date') {                                                // Date validation
      let n = form[f].replace(/-/g, '')
      let m = form[f].replace(/[\/]/g, '')
      if (!isNumeric(n) && !isNumeric(m)) {
        errors.messages.push(`${prettyFieldName} is not a valid date`)
        errors.valueLength.push(f)
        continue
      }
      if (!testDate(form[f])) {
        errors.messages.push(`${prettyFieldName}: please use the YYYY-MM-DD date format`)
        errors.valueLength.push(f)
        continue
      }
      let date = moment(form[f]).format('YYYY-MM-DD')
      if (date === 'Invalid date') {
        errors.messages.push(`${prettyFieldName} is not a valid date`)
        errors.valueLength.push(f)
        continue
      }
      date = moment(date)
      if (!date.isValid()) {
        errors.messages.push(`${prettyFieldName} is not a valid date`)
        errors.valueLength.push(f)
        continue
      }
    }
    if (min && form[name].length < min) {
      errors.messages.push(`${prettyFieldName} must be at least ${min} characters`)
      errors.valueLength.push(f)
      continue
    }
    if (max && form[name].length > max) {
      errors.messages.push(`${prettyFieldName} should not be longer than ${max} characters`)
      errors.valueLength.push(f)
      continue
    }
    if (required && form[name].hasOwnProperty('value') && form[name].value !== null && !form[name].value) {
      errors.messages.push(`${prettyFieldName} is a required field`)
    }
    if (required && dataType === 'number' && typeof form[name] === 'object' && typeof form[name].value !== dataType) {
      errors.messages.push(`Please select a ${prettyFieldName} suggestion from the dropdown list.`)
    } else if (form[name] && dataType && typeof form[name] !== 'object' && typeof form[name] !== dataType) {
      errors.messages.push(`${prettyFieldName} should be of type ${dataType}`)
      errors.typeMismatch.push(f)
    }
  }
  if (errors.messages.length || errors.empty.length || errors.typeMismatch.length || errors.valueLength.length) {
    return errors
  }
  return false
}

/*
* The 'field' object for data entry models (APs, JEs, POs, and PCs) are slightly different. This function flattens the
* 'field' object into an array of 'field' objects, then returns the validated result
* @param {Object} form
* @param {Object} fields
* @return Object or Boolean
*/
export function validateDataEntryModels (form, fields) {
  let flattened = []
  for (let f in fields) {
    if (!fields.hasOwnProperty(f) || !fields[f].inputFields) continue
    fields[f].inputFields.map(v => flattened.push(v))
  }
  return validate(form, flattened)
}

/*
* Checks if required fields contain data
* @param {VueComponent} self
* @return Boolean
*/
/* eslint-disable no-unused-vars */
export function checkIfRequirementsMet (form, fields) {
  if (!fields || (!Array.isArray(fields) && fields.length)) return false
  const r = fields.filter(v => v.hasOwnProperty('required') && v.required)
  const vals = r.map(v => form[v.name].hasOwnProperty('value') ? form[v.name].value : form[v.name])
  return vals.every(v => v)
}

export function checkIfFormIsSaveable (fieldsArr, formObj) {
  let req = []
  let fieldGroups = Object.values(fieldsArr)
  for (let i = 0; i < fieldGroups.length; i++) {
    if (!fieldGroups[i].hasOwnProperty('inputFields')) continue
    req.push([...Object.values(fieldGroups[i].inputFields).filter(v => v.required)])
  }
  req = flattenArrayRecursive(req)
  return req.every(v => {
    const val = formObj[v.name].hasOwnProperty('value') ? formObj[v.name].value : formObj[v.name]
    return !!val
  })
}

export function isNumeric (n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export function testDate (dateStr) {
  return new RegExp(/(\d+)(-|\/)(\d+)(?:-|\/)(?:(\d+)\s+(\d+):(\d+)(?::(\d+))?(?:\.(\d+))?)?/).test(dateStr)
}

export function checkAddressRequirements (address, form) {
  return address.filter(v => !v.name.includes('line2'))
    .every(v => form.hasOwnProperty(v.name) && !!form[v.name])
}



// WEBPACK FOOTER //
// ./src/utils/helpers/Validate.js